import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { PrizeDetailCardConfig } from './prize-detail-card.config';

/**
 * Renders a raffle prize tile (compact tile, or image + details). Everything it needs
 * (layout, typography, card chrome) lives in its own scss so it renders the same in any app.
 * Keep this folder identical in every app.
 */
@Component({
  selector: 'app-prize-detail-card',
  templateUrl: './prize-detail-card.component.html',
  styleUrls: ['./prize-detail-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrizeDetailCardComponent {

  @Input() config: PrizeDetailCardConfig;

  @HostBinding('class.pdc-image') get isImage() {
    return !!this.config?.imagePath;
  }

  @HostBinding('class.pdc-compact') get isCompact() {
    return !!this.config && !this.config.imagePath;
  }

  // scope the branding color to this card so it does not have to be applied to the whole app
  @HostBinding('style.--ion-color-tertiary') get brandColor() {
    return this.config?.brandColor ?? null;
  }

  get layoutClass() {
    return `pdc-layout-${this.config?.layout ?? 'auto'}`;
  }

  get hasWinner() {
    return this.config?.winningNumber != null;
  }
}
